/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IEnumerableOfTransmittalDocumentDto } from './iEnumerableOfTransmittalDocumentDto.schema';

export const TransmittalRecordDto = zod.object({
  "id": zod.string().uuid().optional(),
  "transmittalId": zod.string().optional(),
  "statusId": zod.number().optional(),
  "statusCode": zod.string().optional(),
  "statusName": zod.string().optional(),
  "date": zod.coerce.date().optional(),
  "releasedDate": zod.coerce.date().optional(),
  "receivedDate": zod.coerce.date().optional(),
  "issuerId": zod.string().uuid().optional(),
  "issuerName": zod.string().optional(),
  "receiverId": zod.string().uuid().optional(),
  "receiverName": zod.string().optional(),
  "transmittalDocuments": zod.lazy(() => IEnumerableOfTransmittalDocumentDto).optional()
});

export type TransmittalRecordDto = zod.input<typeof TransmittalRecordDto>;
export type TransmittalRecordDtoOutput = zod.output<typeof TransmittalRecordDto>;
